'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _alias = require('./alias');

var _alias2 = _interopRequireDefault(_alias);

var _STR_ARTICLE = require('./_constants/STR_ARTICLE');

var _STR_ARTICLE2 = _interopRequireDefault(_STR_ARTICLE);

var _STR_ARTICLE_LC = require('./_constants/STR_ARTICLE_LC');

var _STR_ARTICLE_LC2 = _interopRequireDefault(_STR_ARTICLE_LC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Article = (0, _alias2.default)(_STR_ARTICLE_LC2.default, _STR_ARTICLE2.default); /**
                                                                                      * Alias for the article tag.  The Article tag is used to define independent
                                                                                      * content which could be distributed separate from the parent document.
                                                                                      *
                                                                                      * @module Article
                                                                                      * @func
                                                                                      * @since 1.0.0
                                                                                      * @param {Object} props
                                                                                      */

exports.default = Article;